import { Colors, Icon } from "@blueprintjs/core";

const flags = import.meta.glob("./flags/*.svg", {
  query: "?react",
  eager: true,
  import: "default",
});

export function Flag({ countryCode }: { countryCode?: string | null }) {
  const FlagComponent = flags[
    `./flags/${countryCode}.svg`
  ] as React.ComponentType;

  if (!FlagComponent) {
    return <Icon icon="globe" color={Colors.LIGHT_GRAY1} size={24} />;
  }

  return FlagComponent && <FlagComponent />;
}
